export enum RoleEnum {
  UsuarioLeitura = 'USUARIO_LEITURA',
  UsuarioGravacao = 'USUARIO_GRAVACAO',
  UsuarioExclusao = 'USUARIO_EXCLUSAO',
  PerfilLeitura = 'PERFIL_LEITURA',
  PerfilGravacao = 'PERFIL_GRAVACAO',
  PerfilExclusao = 'PERFIL_EXCLUSAO',
  DominioLeitura = 'DOMINIO_LEITURA',
  DominioGravacao = 'DOMINIO_GRAVACAO',
  DominioExclusao = 'DOMINIO_EXCLUSAO',
  SigilosoLeitura = 'SIGILOSO_LEITURA',
  SigilosoGravacao = 'SIGILOSO_GRAVACAO',
  SigilosoExclusao = 'SIGILOSO_EXCLUSAO',
  EntidadeLeitura = 'ENTIDADE_LEITURA',
  EntidadeGravacao = 'ENTIDADE_GRAVACAO',
  EntidadeEdicao = 'ENTIDADE_EDICAO',
  EntidadeExclusao = 'ENTIDADE_EXCLUSAO',
  PessoaLeitura = 'PESSOA_LEITURA',
  PessoaGravacao = 'PESSOA_GRAVACAO',
  PessoaExclusao = 'PESSOA_EXCLUSAO',
  MudancaEntidadeLeitura = 'MUDANCA_ENTIDADE_LEITURA',
  MudancaEntidadeGravacao = 'MUDANCA_ENTIDADE_GRAVACAO',
  MudancaEntidadeEdicao = 'MUDANCA_ENTIDADE_EDICAO',
  MudancaEntidadeExclusao = 'MUDANCA_ENTIDADE_EXCLUSAO',
  VinculoLeitura = 'VINCULO_LEITURA',
  VinculoGravacao = 'VINCULO_GRAVACAO',
  VinculoEdicao = 'VINCULO_EDICAO',
  VinculoExclusao = 'VINCULO_EXCLUSAO',
  consultaLeitura = 'CONSULTA_LEITURA',
  ConsultaGravacap = 'CONSULTA_GRAVACAO',
  ConsultaEdicao = 'CONSULTA_EDICAO',
  ConsultaExclusao = 'CONSULTA_EXCLUSAO',
  DiretorioConsultaLeitura = 'DIRETORIO_LEITURA',
  DiretorioConsultaGravacao = 'DIRETORIO_GRAVACAO',
  DiretorioConsultaEdicao= 'DIRETORIO_EDICAO',
  DiretorioConsultaExclusao = 'DIRETORIO_EXCLUSAO',
  EmailLeitura = 'EMAIL_LEITURA',
  EmailGravacao = 'EMAIL_GRAVACAO',
}



export interface Permissao {
  leitura: boolean;
  gravacao: boolean;
  exclusao: boolean;
}

export interface Tela {
  nome: string;
  permissoes: Permissao;
}

export interface Menu {
  tela: string;
  permissoes: Permissao;
}

export interface Role {
  id: number;
  roleName: string;
  menu: Menu[];
  tela: Tela[];
  role: string

}



export interface FuncaoSistema {
  id: number;
  nome: string;
  telas: Tela[];
}
